import { ApiData } from 'types/api';
import { AppThunk } from 'redux/store';
import { endpoints } from 'api/endpoints';
import { isSuccessResult } from 'utils/guards';
import { Profile } from 'types/api/responses';
import { apiGet } from 'api/karthus.client';
import { ProfileAction, ProfileActions } from 'types/redux/actions/profile.action';

export const getProfile = (account: string): AppThunk<ProfileAction> => {
  return async (dispatch) => {
    dispatch({ type: ProfileActions.profileUpdate, isLoading: true });
    const response = await apiGet<ApiData<Profile>>(endpoints.profile + '/' + account, '');
    if (isSuccessResult(response.result)) {
      dispatch({
        type: ProfileActions.profileSetValue,
        profile: response.result.data,
      });
    } else {
      dispatch({
        type: ProfileActions.profileUpdate,
        isLoading: false,
        error: response.result[0],
      });
    }
  };
};

export const resetProfile = (): AppThunk<ProfileAction> => {
  return (dispatch) => {
    dispatch({
      type: ProfileActions.profileSetValue,
    });
    dispatch({
      type: ProfileActions.resetProfile,
      isLoading: false,
    });
  };
};
